import { SET_FIREBASE_STATIC_DATA } from "../actions";

export function setFirebaseStaticData(payload) {
  return {
    type: SET_FIREBASE_STATIC_DATA,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/setFirebaseStaticData.js